import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.17.1_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.13.11_db0@0.3.2_eslint@_egwkiz5fkkvef52wzw6haion3a/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/opt/buildhome/repo/node_modules/.pnpm/@nuxt+ui-pro@1.8.0_change-case@5.4.4_jwt-decode@4.0.0_magicast@0.3.5_valibot@1.0.0_typescript_a24uw3w7dejdxf3yicfeohjwqe/node_modules/@nuxt/ui-pro/modules/pro/runtime/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}